
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getExtent",
      resolverType: "query",
      routePath: "/getExtent",
      httpMethod: "POST",
    });
  